import { render, staticRenderFns } from "./VerticalScroll.vue?vue&type=template&id=57051966&scoped=true&"
import script from "./VerticalScroll.vue?vue&type=script&lang=js&"
export * from "./VerticalScroll.vue?vue&type=script&lang=js&"
import style0 from "./VerticalScroll.vue?vue&type=style&index=0&id=57051966&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57051966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57051966')) {
      api.createRecord('57051966', component.options)
    } else {
      api.reload('57051966', component.options)
    }
    module.hot.accept("./VerticalScroll.vue?vue&type=template&id=57051966&scoped=true&", function () {
      api.rerender('57051966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/ScrollBars/VerticalScroll.vue"
export default component.exports